/* __next_internal_client_entry_do_not_use__ SDUIComponentClientCodeHandler auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { UserPerceivedLoadTimingContext } from "@faire/web--source/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import { useTraceComponentRender } from "@faire/web--source/common/tracing/useTraceComponentRender";
import { useMergedRefs } from "@faire/web--source/ui/hooks/useMergedRefs";
import React, { forwardRef } from "react";
import { SDUIOnViewHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnViewHandler/SDUIOnViewHandler";
export var SDUIComponentClientCodeHandler = /*#__PURE__*/ forwardRef(function(_param, ref) {
    var isRequiredForInteractivity = _param.isRequiredForInteractivity, rest = _object_without_properties(_param, [
        "isRequiredForInteractivity"
    ]);
    var _React_useContext;
    var UPLTRefCallback = (_React_useContext = React.useContext(UserPerceivedLoadTimingContext)) === null || _React_useContext === void 0 ? void 0 : _React_useContext.refCallback;
    var spanName = rest.loggingData.component_name;
    useTraceComponentRender(spanName ? "SDUIComponent: " + spanName : "SDUIComponentClientCodeHandler");
    var mergedRefs = useMergedRefs(ref, isRequiredForInteractivity ? UPLTRefCallback : undefined);
    return /*#__PURE__*/ _jsx(SDUIOnViewHandler, _object_spread_props(_object_spread({}, rest), {
        ref: mergedRefs
    }));
});
